import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const nav = useNavigate();
  const location = useLocation();

  const isActive = path => location.pathname === path;

  return (
    <footer className='fixed bottom-0 left-0 w-full flex flex-row b2-box bg-white change_text change_2h z-50'>
      <button
        className={`w-full page_center b2-r ${isActive('/mobile/production') ? 'bg-blue-500 text-white' : 'bg-white'}`}
        onClick={() => nav('/mobile/production')}
      >
        생산현황
      </button>
      <button
        className={`w-full page_center b2-r ${
          isActive('/mobile/operationgrid') ? 'bg-blue-500 text-white' : 'bg-white'
        }`}
        onClick={() => nav('/mobile/operationgrid')}
      >
        가동현황(생산)
      </button>
      <button
        className={`w-full page_center b2-r ${
          isActive('/mobile/stopoperation') ? 'bg-blue-500 text-white' : 'bg-white'
        }`}
        onClick={() => nav('/mobile/stopoperation')}
      >
        중지현황(생산)
      </button>
      <button
        className={`w-full page_center b2-r ${isActive('/mobile/stopgrid') ? 'bg-blue-500 text-white' : 'bg-white'}`}
        onClick={() => nav('/mobile/stopgrid')}
      >
        중지현황(소각)
      </button>
    </footer>
  );
};

export default Footer;
